import { useRef } from 'react';

type UseTimeoutProps = {
  timeout: number;
  fireEvent: (props: any) => void;
};
export const useTimeout = ({ timeout, fireEvent }: UseTimeoutProps) => {
  const ref = useRef<ReturnType<typeof setTimeout> | null>(null);

  return (props: any) => {
    if (ref.current) {
      clearTimeout(ref.current);
    }
    ref.current = setTimeout(() => {
      fireEvent(props);
    }, timeout);
  };
};
